import { FormlyFieldConfigMap } from './formly-field-config.map';

const MMSAdminPlaceHolder = 'Search for a Location';

export const mmsAdminOverrideFilterFieldMap: FormlyFieldConfigMap<any> = {
    name: () => ({
        key: 'name',
        templateOptions: {
            label: 'Name or Number',
            maxLength: 512,
            placeholder: MMSAdminPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    })
};
